<div class="row">

  <ng-container *ngIf='templeteType === "list" then logList else form'>
  </ng-container>

  <ng-template #logList>
      <p-confirmDialog [style]="{ width: '50vw' }"></p-confirmDialog>
      <div class="col-12 text-right">
          <button label="Cancel" (click)="navToIndex()" class="mr-2 mb-2 btn btn-sm btn-danger">
  Cancel
</button>

          <button label="Save" type="button" class="mr-2 mb-2 btn btn-sm btn-primary" (click)="openForm()">
Next
</button>
          <!-- <button label="Save" routerLink="add/user" type="button" class="mr-2 mb-2 btn btn-sm btn-info" (click)="updateRetrievalLogData('draft')">
Save Draft
</button>
    <button label="Save" routerLink="add/user" type="button" class="mr-2 mb-2 btn btn-sm btn-primary" (click)="updateRetrievalLogData('submit')">
  Save
</button>
    <button label="Print" class="mr-2 mb-2 btn btn-sm btn-secondary" (click)="openPrintUrl()">
  Print
</button> -->
      </div>
      <div class="col-12">
          <p-table [value]="retreivalLogData">
              <ng-template pTemplate="header">
                  <tr>
                      <th>
                          Stock Area
                      </th>
                      <th>
                          Start Date
                      </th>
                      <th>
                          End Date
                      </th>
                      <th>
                          Expected Count
                      </th>

                      <!--<th>
        Comments
      </th>-->
                      <th>
                          <div class="form-check text-center">
                              Collect Stock Area
                              <div class="form-group" style="margin-bottom:0">
                                  <label for="selectAll" class="text-left"><small>SELECT ALL</small></label>
                                  <input type="checkbox" style="width: 20px; display: inline-block;" name="selectAll" class="form-control maap-w-input-checkbox" id="selectAll" (change)="checkUncheckAll()" [(ngModel)]="masterSelected" />
                              </div>
                          </div>
                      </th>

                  </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowData let-columns="cols">
                  <tr>
                      <td style="height: 50px" *ngFor="let col of cols">
                          <div [ngSwitch]="col.header">

                              <div *ngSwitchCase="'Actual Count'">
                                  <input [(ngModel)]="rowData.actualCounts" name="actualcounts" type="number" class="form-control ml-2" placeholder="" style="width:95%;" />
                              </div>
                              <!--<div *ngSwitchCase="'Comments'">
            <input
              required
              [(ngModel)]="rowData.comments"
              name="comments"
              type="text"
              class="form-control ml-2"
              style="width:95%;"
            />
          </div>-->
                              <div *ngSwitchCase="'Collect Stock Area'">
                                  <div class="form-check text-center">
                                      <input type="checkbox" style="width: 19px; height: 19px; bottom:-9px" name="newregion" class="form-check-input" id="exampleCheck1" (change)="isAllSelected()" [(ngModel)]="rowData.isSelected" />
                                  </div>
                              </div>

                              <div *ngSwitchDefault class="text-center">
                                  {{ rowData[col.field] }}
                              </div>
                          </div>
                      </td>
                  </tr>
              </ng-template>
              <ng-template pTemplate="footer" let-columns>
                  <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td class="text-center">{{totalExpectedCounts}}</td>

                      <td></td>
                  </tr>
              </ng-template>
          </p-table>
      </div>
      <div class="col-12 mt-2">
          <div class="row">
              <div class="col-6 text-left">
                  <button label="Cancel" routerLink="../../index" class="mr-2 mb-2 btn btn-sm btn-primary">Show History</button>
              </div>
              <div class="col-6 text-right"></div>
          </div>

      </div>
  </ng-template>

  <ng-template #form>
      <p-confirmDialog [style]="{ width: '50vw' }"></p-confirmDialog>
      <div class="col-12 text-right">
          <button label="Cancel" (click)="navToIndex()" class="mr-2 mb-2 btn btn-sm btn-danger">
Cancel
</button>


          <button label="Save" routerLink="add/user" type="button" class="mr-2 mb-2 btn btn-sm btn-info" (click)="updateRetrievalLogData('draft')">
Save Draft
</button>
          <button label="Save" routerLink="add/user" type="button" class="mr-2 mb-2 btn btn-sm btn-primary" (click)="updateRetrievalLogData('submit')">
Save
</button>
          <button label="Print" class="mr-2 mb-2 btn btn-sm btn-secondary" (click)="openPrintUrl()">
Print
</button>
      </div>
      <div class="col-12">
          <p-table [value]="retreivalLogSelectedData">
              <ng-template pTemplate="header">
                  <tr>
                      <th *ngFor="let col of formCols">
                          {{col.header}}
                      </th>
                  </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowData let-columns="formCols">
                  <tr>
                      <td style="height: 50px" *ngFor="let col of formCols">
                          <div [ngSwitch]="col.header">

                              <div *ngSwitchCase="'Actual Count'">
                                  <input [(ngModel)]="rowData.actualCounts" name="actualcounts" type="number" class="form-control ml-2" placeholder="" style="width:95%;" />
                              </div>
                              <div *ngSwitchCase="'Time'">
                                  <input [(ngModel)]="rowData.time" name="time" type="time" class="form-control ml-2" placeholder="" style="width:95%;" />
                              </div>
                              <div *ngSwitchCase="'Recon'">
                                  <input [(ngModel)]="rowData.recon" name="recon" type="text" class="form-control ml-2" placeholder="" style="width:95%;" />
                              </div>
                              <div *ngSwitchCase="'Bag'">
                                  <input [(ngModel)]="rowData.bag" name="bag" type="text" class="form-control ml-2" placeholder="" style="width:95%;" />
                              </div>

                              <div *ngSwitchDefault class="text-center">
                                  {{ rowData[col.field] }}
                              </div>
                          </div>
                      </td>

                  </tr>
              </ng-template>


          </p-table>
      </div>

  </ng-template>

</div>
